@if (configJson['type'] == 'discharge_summary') {
  <div class="card">
    <div class="card-header">
      <strong>Discharge Summary</strong>
    </div>
    <div class="card-body">
      <!-- **************** Extra Details of Discharge Summary ********************-->
      @if (showExtradetails) {
        @if (definalizeDetails.isDefinalize == false && checkPermission('add,modify,view','or')) {
          <div [ngClass]="view ? 'overlay' : ''"
            >
            <div class="row">
              <div class="col-sm-1">
                <label class="kx-check-wrapper col-md-3 ml-3 mb-3">
                  <input type="checkbox" class="checkbox"
                    [(ngModel)]="dischargeSummaryExtraDetails.isTreatingDoctor"
                    [checked]="dischargeSummaryExtraDetails.isTreatingDoctor">
                  <span class="kx-check"></span>
                </label>
              </div>
              <div class="col-sm-4">
                <label>Treating Doctor Speciality</label>
                <select class="form-control mb-3"
                  [(ngModel)]="dischargeSummaryExtraDetails.treatingDetails.currentTreatingDoctorSpecialityId"
                  (ngModelChange)="doctorDetails(dischargeSummaryExtraDetails.treatingDetails.currentTreatingDoctorSpecialityId,'treatingDoctorsDischargeSummary',undefined,'treatingDetails','currentTreatingDoctorSpeciality')">
                  <option value="">Select</option>
                  @for (data of specialityDataDischargeSummary; track data) {
                    <option [ngValue]='data.id'>
                    {{data.display}}</option>
                  }
                </select>
                <label>Treating Doctor</label>
                <select class="form-control mb-3"
                  [(ngModel)]="dischargeSummaryExtraDetails.treatingDetails.currentTreatingDoctorId"
                  (ngModelChange)="changeDoctor(dischargeSummaryExtraDetails.treatingDetails.currentTreatingDoctorId,'treatingDoctorsDischargeSummary',undefined,'treatingDetails','currentTreatingDoctor')">
                  <option value="">Select</option>
                  @for (data of dischargeSummaryExtraParameters.treatingDoctorsDischargeSummary; track data) {
                    <option
                    [ngValue]="data.practitioner_id">{{data.display_name}}</option>
                  }
                </select>
              </div>
              <div class="col-sm-1">
                <label class="kx-check-wrapper col-md-3 ml-3 mb-3">
                  <input type="checkbox" class="checkbox"
                    [(ngModel)]="dischargeSummaryExtraDetails.isAdmittingDoctor"
                    [checked]="dischargeSummaryExtraDetails.isAdmittingDoctor">
                  <span class="kx-check"></span>
                </label>
              </div>
              <div class="col-sm-4">
                <label>Admitting Doctor Speciality</label>
                <select class="form-control mb-3"
                  [(ngModel)]="dischargeSummaryExtraDetails.admittingDetails.admittingDoctorSpecialityId"
                  (ngModelChange)="doctorDetails(dischargeSummaryExtraDetails.admittingDetails.admittingDoctorSpecialityId,'admittingDoctorsDischargeSummary',undefined,'admittingDetails','admittingDoctorSpeciality')">
                  <option value="">Select</option>
                  @for (data of specialityDataDischargeSummary; track data) {
                    <option [ngValue]='data.id'>
                    {{data.display}}</option>
                  }
                </select>
                <label>Admitting Doctor</label>
                <select class="form-control mb-3"
                  [(ngModel)]="dischargeSummaryExtraDetails.admittingDetails.admittingDoctorId"
                  (ngModelChange)="changeDoctor(dischargeSummaryExtraDetails.admittingDetails.admittingDoctorId,'admittingDoctorsDischargeSummary',undefined,'admittingDetails','admittingDoctor')">
                  <option value="">Select</option>
                  @for (data of dischargeSummaryExtraParameters.admittingDoctorsDischargeSummary; track data) {
                    <option
                    [ngValue]="data.practitioner_id">{{data.display_name}}</option>
                  }
                </select>
              </div>
              <div class="mt-3">
                <div class="col-lg-12 text-center">
                  <button type="button" class="primary-btn" style="border-radius: 50%;"
                    (click)="addDropdownForDischargeSummary()"><i class="fa fa-plus"></i></button>
                  </div>
                </div>
                <!-- <div class="col-3 border cursor-pointer m-0 p-0" style="height: auto;overflow-x: scroll;" id="scrollTestLab" scroll-directive> -->
                @for (object of dischargeSummaryExtraDetails.additionalDoctorDetails; track object; let i = $index) {
                  <div class="col-sm-3"
                    style="background: #f0f3f5;">
                    <div class="" style="float: right;">
                      <button class="navbar-toggler" type="button"
                        (click)="removeAdditionalDoctorSpeciality(object,i)">
                        <i class="fa fa-times-circle kx-menu-toggle-icon" aria-hidden="true"></i>
                      </button>
                    </div>
                    <ng-container [ngTemplateOutlet]="additionalDoctorSpeciality"
                      [ngTemplateOutletContext]="{object:object,index:i}">
                    </ng-container>
                  </div>
                }
              <!-- </div> -->
            </div>
            <div class="row">
              <div class="col-sm-3">
                <label class="kx-check-wrapper ml-3 mb-3">
                  <input type="checkbox" class="checkbox"
                    [checked]="dischargeSummaryExtraDetails.dischargeType.toLowerCase() == 'expired'"
                    (click)="getDischargeType($event)">
                  <span class="kx-check"></span>Expired Patient
                </label>
              </div>
              <div class="col-sm-4">
                <label>Expected Date of Discharge</label>
                <input type="text" ngxDaterangepickerMd class="form-control choose-date datepicker-search"
                  placeholder="Choose date" showCancel="true" [singleDatePicker]="true" [timePicker]="false"
                  [opens]="'center'" [showDropdowns]="true"
                  [(ngModel)]="dischargeSummaryExtraDetails.expectedDischargeDateAndTime"
                  (change)="selectDateTime($event)" />
              </div>
              <div class="col-sm-5">
                <label>Discharge Summary Print Header</label>
                <select class="form-control mb-2" [(ngModel)]="dischargeSummaryExtraDetails.printHeader">
                  <option value="">Select</option>
                  @for (data of dischargeSummaryExtraParameters.printHeaders; track data) {
                    <option
                    [ngValue]='data.display'>{{data.display}}</option>
                  }
                </select>
              </div>
            </div>
            <ng-template #additionalDoctorSpeciality let-object='object' let-index="index">
              <!-- <div class="row" style="background: #f0f3f5;">
              <div class="" style="float: right;">
                <button class="navbar-toggler" type="button" (click)="removeAdditionalDoctorSpeciality(object)">
                  <i class="fa fa-times-circle kx-menu-toggle-icon" aria-hidden="true"></i>
                </button>
              </div> -->
              <div>
                <label>Speciality</label>
                <select class="form-control mb-2"
                  [(ngModel)]="dischargeSummaryExtraDetails.additionalDoctorDetails[index].specialityId"
                  (ngModelChange)="doctorDetails(dischargeSummaryExtraDetails.additionalDoctorDetails[index].specialityId,'additionalDoctorsDischargeSummary',index,'additionalDoctorDetails')">
                  <option value="">Select</option>
                  @for (data of specialityDataDischargeSummary; track data) {
                    <option [ngValue]='data.id'>
                    {{data.display}}</option>
                  }
                </select>
                <label>Doctor</label>
                <select class="form-control mb-2"
                  [(ngModel)]="dischargeSummaryExtraDetails.additionalDoctorDetails[index].doctorId"
                  (ngModelChange)="changeDoctor(dischargeSummaryExtraDetails.additionalDoctorDetails[index].doctorId,'additionalDoctorsDischargeSummary',index,'additionalDoctorDetails')">
                  <option value="">Select</option>
                  @for (data of dischargeSummaryExtraParameters.additionalDoctorsDischargeSummary[index]; track data) {
                    <option
                    [ngValue]='data.practitioner_id'>{{data.display_name}}</option>
                  }
                </select>
              </div>
            <!-- </div> -->
          </ng-template>
          <!-- ************************************************************************ -->
        </div>
      }
    }
    <ng-template [ngTemplateOutlet]="bodyTemplate"></ng-template>
  </div>
</div>
}
@if (configJson['type'] != 'discharge_summary') {
  <div>
    @if (configJson['backNavigation'] ==true) {
      <div class="page-title-container d-flex">
        @if (!utilService.isMobile()) {
          <div class="page-title flex-grow-1">
            <div class="mb-0">
              <div class="pr-2">
                <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                  <img src="assets/images/grid-back.png" />
                </a>
                {{_currentTemplateName}}
              </div>
            </div>
          </div>
        }
      </div>
    }
    <ng-template [ngTemplateOutlet]="bodyTemplate"></ng-template>
  </div>
}
<ng-template #bodyTemplate>
  <div class="row m-0 p-0 bg-white shadow-sm" [ngClass]="{'mt-4':!configJson['backNavigation']}">
    @if (configJson.showPreviousTemplates) {
      <div
        [ngClass]="checkPermission('modify,add,view,definalize','or') ? 'col-3 border cursor-pointer' : 'col-12 border cursor-pointer'"
        style="padding: 0px !important;">
        <div class="p-1" style="text-align: center;">
          @if (preFilledtemplates.length > 0) {
            <button type="button"
              [attr.disabled]="_currentPage == 0 ? '' : null" class="pull-left btn btn-outline-primary btn-sm"
              (click)="goPrev()"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
            }
            @if (preFilledtemplates.length > 0) {
              <button type="button"
                class="pull-right btn btn-outline-primary btn-sm" [attr.disabled]="getClassToEnableDisableIcon()"
                (click)="goNext()"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
              }
              <h4>
                Template History ({{allTemplateCount?allTemplateCount:0}})
              </h4>
            </div>
          </div>
        }
        @if (configJson.showTemplateList && checkPermission('modify,add,view,definalize','or')) {
          <div
            [ngClass]="configJson.showPreviousTemplates ? 'col-9 border cursor-pointer' : 'col-12 border cursor-pointer'">
            @if (checkPermission('add')) {
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-right p-1">
                <select class="form-control" [disabled]="dropdownDisable" [(ngModel)]="template"
                  (change)="valueChange(template)">
                  <option value="" selected>--Select Template--</option>
                  @for (data of templates; track data) {
                    <option [value]='data.id'>{{data.name}}</option>
                  }
                </select>
              </div>
            }
          </div>
        }
      </div>
      <div class="row m-0 p-0 bg-white shadow-sm">
        @if (configJson.showPreviousTemplates) {
          <div
            [ngClass]="checkPermission('modify,add,view,definalize','or') ? 'col-3 border cursor-pointer m-0 p-0' : 'col-12 border cursor-pointer m-0 p-0'"
            style="height: auto;overflow-y: scroll;" id="scrollTestLab" scroll-directive
            (onScroll)="onScrollList($event)">
            @for (item of preFilledtemplates; track item; let i = $index) {
              <div class="border p-1 doc-view-list"
                [ngClass]="{'doc-active-tab': i==0?true:false}">
                <div class="row">
                  <div class="col-10">
                    <span class="text-primary font-weight-bold">{{item.templateName}}</span><br>
                  </div>
                  @if (checkPermission('delete') && item.status.toLowerCase() == 'draft') {
                    <span
                      (click)="deleteDraftTemplate(item)"><i class="fa fa-trash-o"
                    style="color: red;cursor: pointer;"></i></span>
                  }
                </div>
                <span> <b>Status :</b> {{item.status?item.status:''}} </span><br>
                <span> <b>Created Date :</b> {{item.g_creation_time?(item.g_creation_time | date:'medium'):'' }} </span>
                <div>
                  @if (checkPermission('view')) {
                    <a (click)="viewTemplate(item)"
                    class="card-link text-primary">View</a>
                  }
                  @if (checkPermission('modify') && item.status && item.status.toLowerCase() !='final') {
                    <a
                    (click)="editTemplate(item)" class="card-link text-primary">Edit</a>
                  }
                  @if (checkPermission('print')) {
                    <a (click)="printTemplate(item)"
                    class="card-link text-primary">Print</a>
                  }
                  @if (configJson['type'] == 'discharge_summary' && item['status'].toLowerCase() == 'final' && checkPermission('definalize')) {
                    <a
                    (click)="definalizeSummary(item)" class="card-link text-danger">DeFinalize</a>
                  }
                </div>
              </div>
            }
            @if (preFilledtemplates.length == 0) {
              <div class="border p-3 doc-view-list" id="notemp"
                style="text-align: center;">
                <span>No template created yet.</span>
              </div>
            }
          </div>
        }

        @if (checkPermission('modify,add,view, definalize','or')) {
          <div
            [ngClass]="configJson.showPreviousTemplates ? 'col-9 border' : 'col-12 border'" id="scrollsTestLab"
            style="height: auto;overflow-y: scroll;">
            @if (!definalizeDetails.isDefinalize) {
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  @if (!configJson['backNavigation']) {
                    <div style="text-align: center;" class="p-2">
                      @if (view || !dischargeSummaryFilled) {
                        <h4>{{_currentTemplateName}}</h4>
                      }
                    </div>
                  }
                  @if (form && formData && _currentData && show && !dischargeSummaryFilled) {
                    <dhs-form [action]="configJson['currentAction']?configJson['currentAction']:'ADD'"
                      [fieldGroup]="formData" [data]="_currentData" [customButton]="customButton"
                      (saveFinished)="onSaveFinished($event)" (scoreValueChanged)="scoreValueEvent($event)"
                      [config]="config" (questionValueChanged)="questionValueChanged($event)">
                    </dhs-form>
                  }
                  @if (view && _currentData && formData) {
                    @if (checkPermission('print_in_view')) {
                      <div class="d-flex flex-row-reverse mb-1">
                        <button class="btn primary-btn print_in_view mt-1" (click)="printTemplate({'id':observationId})"
                          >
                          <i class="fa fa-print"></i> Print
                        </button>
                      </div>
                    }
                    <dhs-form-view [data]="_currentData" [fieldGroup]="formData" [buttonConf]=false></dhs-form-view>
                  }
                </div>
              </div>
            }
            @if (definalizeDetails.isDefinalize) {
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div style="text-align: center;" class="p-2">
                    @if (view || !dischargeSummaryFilled) {
                      <h4>{{_currentTemplateName}}</h4>
                    }
                  </div>
                  <div>
                    <label class="text-primary font-weight-bold">Reason For DeFinalize<sup
                    class="req">*</sup></label>
                    <textarea rows="8" class="form-control" [(ngModel)]="definalizeDetails.reason" name="reason"
                    placeholder="Enter reason to definalize discharge summary..."></textarea>
                  </div>
                  @if (definalizeDetails.reason) {
                    <div class="text-center">
                      <button class="btn btn-danger mt-2 mb-2"
                      (click)="definalizeDetailsOfSummary()">DeFinalize</button>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </ng-template>